import React, { useState } from "react";

// Uses the existing Owner-only Story Hub metadata save callback.
export default function StoryTeaserEditor({ story, language = "en", onSave }) {
  const fr = language === "fr";
  const teaser = typeof story?.storyTeaser === "string" ? story.storyTeaser.trim() : "";
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(teaser);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const words = (draft.trim().match(/\S+/g) || []).length;
  const tooLong = words > 90 || draft.length > 900;

  async function save() {
    if (saving || tooLong || typeof onSave !== "function") return;
    setSaving(true);
    setMessage(fr ? "Enregistrement…" : "Saving…");
    try {
      const result = await onSave(draft.trim());
      if (result?.ok) {
        setEditing(false);
        setMessage("");
      } else {
        setMessage(String(result?.message || (
          fr ? "L’enregistrement n’a pas été confirmé." : "The save was not confirmed."
        )));
      }
    } catch (error) {
      setMessage(String(error?.message || (
        fr ? "Impossible d’enregistrer." : "Could not save."
      )));
    } finally {
      setSaving(false);
    }
  }

  return (
    <section className="ns-card ns-card-soft" style={{ marginTop: 10 }} onClick={(event) => event.stopPropagation()}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
        <div>
          <h4 className="ns-card-title" style={{ margin: 0 }}>{fr ? "Accroche du livre" : "Story Teaser"}</h4>
          <p className="ns-card-meta" style={{ margin: "5px 0 0" }}>
            {fr
              ? "Un texte court, approuvé par l’auteur, distinct du synopsis. Seules les accroches enregistrées apparaissent dans la bibliothèque."
              : "A short, author-approved invitation to read, separate from the synopsis. Only saved teasers appear in the Story Library."}
          </p>
        </div>
        <button
          type="button"
          className="ns-button ns-button-outline"
          disabled={saving}
          onClick={() => {
            if (editing) {
              setEditing(false);
              setMessage("");
            } else {
              setDraft(teaser);
              setMessage("");
              setEditing(true);
            }
          }}
        >
          {editing ? (fr ? "Annuler" : "Cancel") : teaser ? (fr ? "Modifier" : "Edit") : (fr ? "Ajouter" : "Add")}
        </button>
      </div>
      {editing ? (
        <>
          <textarea
            rows={5}
            maxLength={900}
            value={draft}
            onChange={(event) => { setDraft(event.target.value); setMessage(""); }}
            placeholder={fr
              ? "Éveillez la curiosité sans révéler les secrets de l’histoire…"
              : "Spark curiosity without revealing the story's secrets…"}
            style={{ width: "100%", marginTop: 10, resize: "vertical" }}
            aria-label={fr ? "Texte de l’accroche" : "Story teaser text"}
          />
          <div style={{ display: "flex", gap: 12, justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", marginTop: 10 }}>
            <span className="ns-card-meta" aria-live="polite">
              {message || `${words}/90 ${fr ? "mots" : "words"} · ${draft.length}/900`}
            </span>
            <button type="button" className="ns-button ns-button-primary" onClick={save} disabled={saving || tooLong}>
              {saving ? (fr ? "Enregistrement…" : "Saving…") : (fr ? "Enregistrer l’accroche" : "Save Story Teaser")}
            </button>
          </div>
          <p className="ns-card-meta" style={{ margin: "8px 0 0" }}>
            {fr ? "Enregistrer un texte vide retire le bouton public." : "Saving an empty teaser removes the public button."}
          </p>
        </>
      ) : (
        <p className="ns-card-meta" style={{ margin: "10px 0 0", whiteSpace: "pre-wrap" }}>
          {teaser || (fr ? "Aucune accroche publiée." : "No teaser published yet.")}
        </p>
      )}
    </section>
  );
}
